import React from "react";
import PointsMenu from "./PointsMenu";
import EarnPointsForm from "./EarnPointsForm";
import PointsRedemption from "./PointsRedemption";
import OfferIncentives from "./OfferIncentives";
import SelectLocations from "./SelectionLocations";

import "./styles.css";

class LoyaltySetup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeView: "init_menu"
    };
    this.changeView = this.changeView.bind(this);
  }

  changeView(activeView) {
    this.setState({ activeView });
  }

  renderView() {
    switch (this.state.activeView) {
      case "init_menu":
        return <PointsMenu changeView={this.changeView}/>;
      case "earn_points":
        return <EarnPointsForm changeView={this.changeView}/>;
      case "redeem_points":
        return <PointsRedemption changeView={this.changeView}/>;
      case "offer_incentives":
        return <OfferIncentives changeView={this.changeView}/>;
      case "select_locations":
        return <SelectLocations changeView={this.changeView}/>;
      default:
        return <PointsMenu changeView={this.changeView}/>;
    }
  }

  render() {
    return this.renderView();
  }
}

export default LoyaltySetup;



// WEBPACK FOOTER //
// ./src/containers/LoyaltySetup/index.js